<template>
    <section class="py-12 relative">

        <div class="w-full flex flex-row gap-12 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div class="w-1/2">
                <SectionHeader :subheader="subheader" :title="title" />

                <div class="space-y-2 mt-2">
                    <div
                        v-for="(step, index) in steps"
                        :key="index"
                        class="cursor-pointer rounded-lg transition-colors hover:bg-primary-50/50"
                        :class="{ 'bg-primary-50': selectedStep === index }"
                        @click="selectStep(index)"
                    >
                        <FeatureStep
                            :icon="step.icon"
                            :title="step.title"
                            :description="step.description"
                            :isSelected="selectedStep === index"
                            isSelectable
                        />
                    </div>
                </div>
            </div>

            <div class="w-1/2">
                <div class="left-1/2 ml-32 w-[300px] z-30">
                    <DeviceWrapper deviceType="phone" :width="100" :z="0" :x="0" :y="-8" :rotateOnScroll="false" :imageSrc="steps[selectedStep].image" />
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import DeviceWrapper from '../DeviceWrapper.vue'
import SectionHeader from './SectionHeader.vue'
import FeatureStep from './FeatureStep.vue'

const props = defineProps({
    steps: {
        type: Array,
        default: () => []
    },
    subheader: {
        type: String,
        default: ''
    },
    title: {
        type: String,
        default: ''
    }
})

const selectedStep = ref(0)

const STEP_INTERVAL_MS = 5000
let stepTimer = null

function startStepTimer() {
    if (stepTimer) clearInterval(stepTimer)
    if (props.steps.length <= 1) return
    stepTimer = setInterval(() => {
        selectedStep.value = (selectedStep.value + 1) % props.steps.length
    }, STEP_INTERVAL_MS)
}

function selectStep(index) {
    selectedStep.value = index
    startStepTimer()
}

onMounted(() => {
    startStepTimer()
})

onUnmounted(() => {
    if (stepTimer) clearInterval(stepTimer)
})
</script>